module.exports = __webpack_public_path__ + "img/adobe-5.7dc70ad0.png";